// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Tag_wrap__3chcO","hidden":"Tag_hidden__25e61","button":"Tag_button__2NJhn","buttonLine":"Tag_buttonLine__1hgr4"};